// extracted by mini-css-extract-plugin
export default {"styleCenterAndFixed":"nP07Bg","button":"x11aD0"};